/**
 * @description 커스텀 웰로 서비스를 사용하는 서브 도메인 등록
 */
export enum SUB_DOMAIN {
  WELLO = 'www',
  WELLO_APP = 'app',
  KB_PAY = 'kbpay',
  TOSS = 'toss',
  KAKAOBANK = 'kakaobank',
}

export const PARTNER_SUB_DOMAIN_LIST: readonly SUB_DOMAIN[] = [
  SUB_DOMAIN.KB_PAY,
  SUB_DOMAIN.TOSS,
  SUB_DOMAIN.KAKAOBANK,
];
